export default __webpack_public_path__ + "static/media/bg.62e15642.jpg";